export default "__VITE_ASSET__CsU5WBum__"